<template>
    <CompassTable
        :isCheckable="false"
        class="invoicing-display-settings-loader"
        :size="CompassEnums.TableSize.MEDIUM"
    >
        <CompassTableHead>
            <CompassTableHeadCell>
                <CompassSkeleton
                    class="invoicing-display-settings-loader__line"
                    :size="CompassEnums.SkeletonSize.LARGE"
                />
            </CompassTableHeadCell>
            <CompassTableHeadCell>
                <CompassSkeleton
                    class="invoicing-display-settings-loader__line"
                    :size="CompassEnums.SkeletonSize.LARGE"
                />
            </CompassTableHeadCell>
        </CompassTableHead>
        <CompassTableRow v-for="n in 4" :key="n">
            <CompassTableBodyCell>
                <CompassSkeleton
                    class="invoicing-display-settings-loader__line"
                    :size="CompassEnums.SkeletonSize.LARGE"
                />
            </CompassTableBodyCell>
            <CompassTableBodyCell class="invoicing-display-settings-loader__fixed-width-cell">
                <CompassSkeleton
                    class="invoicing-display-settings-loader__square"
                    :variant="CompassEnums.SkeletonVariantType.SQUARE"
                    :size="CompassEnums.SkeletonSize.MEDIUM"
                />
                <CompassSkeleton
                    class="invoicing-display-settings-loader__line"
                    :size="CompassEnums.SkeletonSize.LARGE"
                />
            </CompassTableBodyCell>
        </CompassTableRow>
    </CompassTable>
</template>
<style lang="scss" scoped>
.invoicing-display-settings-loader {
    &__line {
        width: 200px;
    }

    &__square {
        margin: 0 var(--spacing-4) 0 0;
    }

    &__fixed-width-cell {
        white-space: nowrap;
        width: 1%;
    }

    :deep(.compass-table-body__row:hover) {
        background-color: transparent;

        td {
            background-color: transparent;
        }
    }
}
</style>
